import { formatCurrency } from '@/lib/format'
import type { AreaSurcharge, AreaSurchargeEnd } from '@/types/api'

/**
 * Words for a booking's Cairo area surcharge, shared by the chips, the detail
 * rows and the exports so every screen names a place the same way.
 */

/** "Nasr City · East Cairo", "Maadi · no group", or "Outside the sub-areas". */
export function describeEnd(end: AreaSurchargeEnd): string {
  if (!end.subArea) return 'Outside the sub-areas'
  return `${end.subArea} · ${end.group ?? 'no group'}`
}

/** What one end added: "+E£80", or "no surcharge". */
export function describeEndCharge(end: AreaSurchargeEnd): string {
  return end.surchargeMinor > 0 ? `+${formatCurrency(end.surcharge)}` : 'no surcharge'
}

/**
 * The line an export cell carries, or an empty string when the booking's ends
 * fell in no sub-area. The server words it; the fallback is only for a
 * response that carries the ends without the summary.
 */
export function describeAreaSurcharge(area: AreaSurcharge | null | undefined): string {
  if (!area || !area.any) return ''
  return (
    area.summary ??
    `${describeEnd(area.pickup)} → ${describeEnd(area.dropoff)} · ${
      area.totalMinor > 0 ? `+${formatCurrency(area.total)}` : 'no surcharge'
    }`
  )
}
